import React from 'react';
import CommonModal from '../components/modals/common/Modal';
import { messageUtility } from '../utilities/messageUtility';

const TITLE = `編集画面を閉じる`;
const MESSAGE = messageUtility.getMessage('I-000-confirmCloseEditWindow');
const CANCEL_BUTTON_TEXT = `戻る`;
const CONFIRM_BUTTON_TEXT = messageUtility.getMessage('I-000-closeEditWindow');
/**
 * 編集画面を閉じるモーダル
 *
 * @param {*} props
 * @returns
 */
export const CloseEditView = props => {
  const { dialog } = props;
  return (
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>{dialog.title || TITLE}</span>
      </div>
      <div
        className={`dialog-md__body ${
          dialog.multilineText
            ? 'dialog-md__body-prewrap'
            : 'flex justify-center'
        } text-left`}
      >
        <div style={{ fontSize: '13px' }}>{dialog.message || MESSAGE}</div>
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          className='btn-fixedsize--sub'
          onClick={() => {
            dialog.callback.close();
          }}
        >
          {CANCEL_BUTTON_TEXT}
        </button>
        <button
          className='btn-fixedsize--negative'
          onClick={() => {
            dialog.callback.clear();
          }}
        >
          {dialog.confirmButtonName || CONFIRM_BUTTON_TEXT}
        </button>
      </div>
    </div>
  );
};

export const CloseEditDialog = props => {
  const { visible, onCancel, onConfirm } = props;

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div className={'dialog-md dialog--modal'}>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>{TITLE}</span>
            </div>
            <div className='dialog-md__body text-left'>{MESSAGE}</div>
            <div className={'dialog-md__footer-horizontal'}>
              <React.Fragment>
                <button className='btn--sub' onClick={onCancel}>
                  {CANCEL_BUTTON_TEXT}
                </button>
                <button className='btn--negative' onClick={onConfirm}>
                  {CONFIRM_BUTTON_TEXT}
                </button>
              </React.Fragment>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/CloseEditView.jsx